import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import _ from "underscore";
Object.defineProperty(Vue.prototype, "$_", { value: _ });

import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");
Vue.prototype.$moment = moment;

Vue.prototype.$t = function(str) {
  return str;
};

import VueQrcode from "@chenfengyuan/vue-qrcode";
Vue.component(VueQrcode.name, VueQrcode);

function slugify(string) {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  const p = new RegExp(a.split("").join("|"), "g");

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

new Vue({
  render: (h) => h(App),
  data: {
    current_page: "articles",
    dodoc_url: "https://dodoc.tierslieuxedu.org/",
    state: {
      dev_mode: "debug",
      modal: {
        current_publication_slug: false,
      },
    },
    publicPath: process.env.BASE_URL,

    publications: {},
    authors: {},
    is_loading: true,

    copy_content: {
      title: "",
      subtitle: "",
      description: "",
      infos: "",
      parcours: "",
      footer: "",
      logos: [],
    },
  },
  created() {
    window.onpopstate = (event) => {
      console.log(
        `ROOT EVENT: popstate with event.state.slug = ${event.state.slug}`
      );
      if (event.state.slug)
        this.state.modal.current_publication_slug = event.state.slug;
      else this.state.modal.current_publication_slug = false;
    };

    // fetch("https://dodoc.tierslieuxedu.org/api/publications", {
    //   headers: {
    //     "Content-Type": "application/json",
    //     Origin: "https://fabriqueedu.tierslieuxedu.org",
    //   },
    // }).then((response) => {
    //   if (!response.ok) throw new Error(response.status);
    //   console.log("got content");
    //   response.json().then((data) => {
    //     Object.entries(data).map(([slugFolderName, meta]) => {
    //       this.$set(this.publications, slugFolderName, meta);

    //       fetch(
    //         `https://dodoc.tierslieuxedu.org/api/publications/${slugFolderName}`,
    //         {
    //           headers: {
    //             "Content-Type": "application/json",
    //             Origin: "https://fabriqueedu.tierslieuxedu.org",
    //           },
    //         }
    //       ).then((response) => {
    //         response.json().then((data) => {
    //           const medias = Object.values(data)[0].medias;
    //           if (medias) this.publications[slugFolderName].medias = medias;
    //         });
    //       });
    //     });
    //     // data.publications.map((p) => {
    //     //   if (p) {
    //     //   }
    //     // });

    //     this.is_loading = false;
    //   });
    // });

    fetch("https://fabriqueedu.tierslieuxedu.org/index.php").then(
      (response) => {
        // fetch("simulation.json").then((response) => {
        if (!response.ok) throw new Error(response.status);
        console.log("got content");
        response.json().then((data) => {
          data.publications.map((p) => {
            if (p) {
              Object.entries(p).map(([slugFolderName, meta]) => {
                this.$set(this.publications, slugFolderName, meta);
              });
            }
          });

          Object.entries(data.authors).map(([slugFolderName, meta]) => {
            if (slugFolderName && meta)
              this.$set(this.authors, slugFolderName, meta);
          });

          if (data.projects.hasOwnProperty("contenus-du-site-fabriqueedu")) {
            const content = data.projects["contenus-du-site-fabriqueedu"];

            Object.keys(this.copy_content).map((k) => {
              const specific_content = Object.values(content.medias).filter(
                (c) =>
                  c.keywords &&
                  c.keywords.some((keyword) => keyword.title === k)
              );

              if (specific_content && specific_content.length > 0) {
                if (typeof this.copy_content[k] === "string")
                  this.copy_content[k] = specific_content[0].content;
                if (Array.isArray(this.copy_content[k]))
                  this.copy_content[k] = specific_content;
              }

              if (this.copy_content.hasOwnProperty("title")) {
                document.title = this.copy_content.title
                  .replace(/&nbsp;/gi, " ")
                  .replace(/(<([^>]+)>)/gi, "");
              }
            });
          }

          this.$nextTick(() => {
            this.is_loading = false;

            if (
              window.location.pathname &&
              window.location.pathname.length > 1
            ) {
              const slug = window.location.pathname.substring(1);
              if (
                this.recipes_of_this_template.some(
                  (f) => f.slugFolderName === slug
                )
              ) {
                this.state.modal.current_publication_slug = slug;
              }
            }
          });
        });
      }
    );
  },
  watch: {
    current_publication_opened: function() {
      if (typeof history.pushState != "undefined") {
        if (this.current_publication_opened) {
          var obj = {
            title: this.current_publication_opened.name,
            slug: this.current_publication_opened.slugFolderName,
          };
          history.pushState(obj, obj.title, obj.slug);
        } else {
          history.pushState({ slug: "" }, "", "/");
        }
      }
    },
  },
  computed: {
    recipes_of_this_template() {
      const template_key = "page_by_page";

      const filtered_recipes = Object.values(this.$root.publications).filter(
        (r) => r.template === template_key && !!r.date_submitted
      );

      // filtered_recipes[0].keywords = [
      //   {
      //     title: "plip"
      //   }
      // ];
      // filtered_recipes[1].keywords = [
      //   {
      //     title: "plip"
      //   }
      // ];
      // filtered_recipes[2].keywords = [
      //   {
      //     title: "plop"
      //   }
      // ];

      let sorted_recipes = this.$_.sortBy(filtered_recipes, "date_created");
      sorted_recipes = sorted_recipes.reverse();

      return sorted_recipes;
    },
    current_publication_opened() {
      if (!this.state.modal.current_publication_slug) return false;
      return this.recipes_of_this_template.find(
        (f) =>
          f.slugFolderName === this.$root.state.modal.current_publication_slug
      );
    },
  },
  methods: {
    changePage() {
      if (this.current_page === "articles") {
        this.current_page = "informations";
      } else if (this.current_page === "informations") {
        this.current_page = "articles";
      }
      setTimeout(() => window.scrollTo(0, 0), 200);
    },
    formatDateToHuman(date) {
      return this.$moment(date, "YYYY-MM-DD HH:mm:ss").format("LL");
    },
    formatListToHuman(list) {
      return list.reduce(
        (text, value, i, array) =>
          text + (i < array.length - 1 ? ", " : " et ") + value
      );
    },
    getFileMeta({ type, media }) {
      if (
        media.hasOwnProperty("file_meta") &&
        media.file_meta.some((f) => f.hasOwnProperty(type))
      ) {
        return media.file_meta.find((f) => f.hasOwnProperty(type))[type];
      }
      if (media.hasOwnProperty(type)) return media[type];

      if (media.hasOwnProperty("_linked_media")) {
        if (
          media._linked_media.hasOwnProperty("file_meta") &&
          media._linked_media.file_meta.some((f) => f.hasOwnProperty(type))
        )
          return media._linked_media.file_meta.find((f) =>
            f.hasOwnProperty(type)
          )[type];

        if (
          media._linked_media.hasOwnProperty(type) &&
          media._linked_media[type]
        )
          return media._linked_media[type];
      }

      return false;
    },
    getPublications({ template, follows_model, keyword }) {
      return Object.values(this.$root.publications).filter(
        (p) =>
          p.template === template &&
          p.follows_model === follows_model &&
          !!p.date_submitted &&
          (!keyword ||
            (p.keywords && p.keywords.find((k) => k.title === keyword)))
      );
    },
  },
}).$mount("#app");
